export default {"src":"/_next/static/media/bookmark.8d53d312.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};